import { Dispatch, SetStateAction, useEffect, useState } from "react";
import AcedTextBox from "../../../../../scenes/messages/chat/AcedTextBox";
import { PostApiRoutes } from "../../../../../shared/api-routes/post/post.api-routes";
import http from "../../../../../shared/utils/http";
import LoadingSpinner from "../../../../essentials/loading-spin/LoadingSpinner";
import Comment, { CommentInfo } from "../comment/Comment";
import "./CommentModal.scss";

export interface CommentModalProps {
	post_id: string;
	state: {
		setCommentCount: Dispatch<SetStateAction<number>>;
		commentCount: number;
	};
}

const CommentModal: React.FC<CommentModalProps> = ({ post_id, state }) => {
	const [comments, setComments] = useState<CommentInfo[]>([]);
	const [writeComment, setWriteComment] = useState<string>("");

	const [loading, setLoading] = useState<boolean>(true);

	useEffect(() => {
		http.get(PostApiRoutes.GET_COMMENTS(post_id)).then((res) => {
			setComments(res);
			setLoading(false);
		});
	}, [post_id]);

	const addComment = () => {
		http
			.post(PostApiRoutes.COMMENT_POST(post_id), { content: writeComment })
			.then((res) => {
				setWriteComment("");
				setComments((prev) => [res, ...prev]);
				state.setCommentCount((prev) => prev + 1);
			});
	};

	const onDeleteComment = (comment_id: string) => {
		setComments((prev) => prev.filter((comment) => comment.id !== comment_id));
		state.setCommentCount((prev) => prev - 1);
	};

	return (
		<div className="comment-modal">
			{/* <div className="create-comment-input"> */}
			<AcedTextBox
				text={writeComment}
				setText={setWriteComment}
				placeholder={`${
					state.commentCount === 0
						? "Be the first to comment..."
						: "Add a comment..."
				}`}
				onSend={addComment}
				mode="dark"
			/>
			{/* <CommentTextBox
          textState={{ text: writeComment, setText: setWriteComment }}
          onSend={addComment}
          placeholder={`${
            state.commentCount === 0
              ? "Be the first to comment..."
              : "Add a comment..."
          }`}
        /> */}
			{/* </div> */}
			{state.commentCount === 0 && (
				<div style={{ color: "white" }}>There are no comments yet</div>
			)}
			{loading && state.commentCount > 0 ? (
				<LoadingSpinner />
			) : (
				<>
					{comments.map((comment, index) => {
						return (
							<div
								className="comments"
								key={comment.id}
							>
								{index > 0 ? <div className="divider" /> : ""}
								<div>
									<Comment
										postId={post_id}
										onDeleteComment={onDeleteComment}
										comment={comment}
									/>
									{/* <CommentReplies /> */}
								</div>
							</div>
						);
					})}
				</>
			)}
		</div>
	);
};

export default CommentModal;
